import React from 'react';
import CallToActionWidget from 'applications/static-pages/cta-widget';

const ViewPaymentHistoryCTA = () => (
  <div>
    <CallToActionWidget appId="view-payment-history" />
  </div>
);

export default ViewPaymentHistoryCTA;
